module.exports = __webpack_public_path__ + "img/fortune.51a5d8dd.png";